// extracted by mini-css-extract-plugin
module.exports = {"navigationToggle":"NavigationToggle_navigationToggle__NMFMW"};